export default "__VITE_ASSET__Db9pnkFe__"